import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/_authenticated/report')({
  component: RouteComponent,
  staticData: {
    breadcrumb: ['My reports']
  }
})

function RouteComponent() {
  return (<Outlet />);
}
